/**
 * App store download URLs.
 * Replace these placeholders when Play Store / App Store listings are live.
 */
export const APP_STORE_URLS = {
  googlePlay: '#', // TODO: replace with Google Play listing URL
  appleAppStore: '#', // TODO: replace with Apple App Store listing URL
};

export const isStoreLinkReady = (url) =>
  typeof url === 'string' && url !== '#' && /^https?:\/\//i.test(url);
